import React from "react";
import { useNavigate } from "react-router-dom";

export default function PageTypeSelection() {
  const navigate = useNavigate();

  const handleSelect = (type) => {
    navigate(`/create-page/${type}`);
  };

  const pageTypes = [
    {
      type: "grid-guide",
      title: "Grid Guide",
      description:
        "Interactive category tabs, each revealing a grid of product cards. Great for 'best X for your Y' style guides (e.g. best sunglasses for your face shape).",
      skeleton: (
        <div className="flex flex-col space-y-2 border border-gray-300 p-2 rounded-md h-full bg-white">
          <div className="w-full h-10 bg-gray-200 rounded"></div>
          <div className="flex space-x-1">
            <div className="flex-1 h-5 bg-gray-200 rounded"></div>
            <div className="flex-1 h-5 bg-gray-300 rounded"></div>
            <div className="flex-1 h-5 bg-gray-200 rounded"></div>
            <div className="flex-1 h-5 bg-gray-200 rounded"></div>
          </div>
          <div className="grid grid-cols-4 gap-1">
            <div className="h-8 bg-gray-200 rounded"></div>
            <div className="h-8 bg-gray-200 rounded"></div>
            <div className="h-8 bg-gray-200 rounded"></div>
            <div className="h-8 bg-gray-200 rounded"></div>
          </div>
        </div>
      ),
    },
    {
      type: "listicle",
      title: "Ranked Listicle",
      description:
        "A ranked editorial roundup: hero with review badges, 'how we picked', numbered product cards each with an Editor's Take, a comparison table, and a final verdict CTA.",
      skeleton: (
        <div className="flex flex-col space-y-2 border border-gray-300 p-2 rounded-md h-full bg-white">
          <div className="w-full h-10 bg-gray-200 rounded"></div>
          <div className="flex space-x-2 items-center">
            <div className="w-1/3 h-10 bg-gray-300 rounded"></div>
            <div className="flex-1 flex flex-col space-y-1">
              <div className="h-3 bg-gray-200 rounded w-1/2"></div>
              <div className="h-3 bg-gray-200 rounded"></div>
            </div>
          </div>
          <div className="flex space-x-2 items-center">
            <div className="w-1/3 h-10 bg-gray-300 rounded"></div>
            <div className="flex-1 flex flex-col space-y-1">
              <div className="h-3 bg-gray-200 rounded w-1/2"></div>
              <div className="h-3 bg-gray-200 rounded"></div>
            </div>
          </div>
        </div>
      ),
    },
  ];

  return (
    <div className="p-6 h-screen overflow-y-auto">
      <h1 className="text-2xl font-bold mb-2">Select Page Type</h1>
      <p className="text-gray-500 mb-6">
        The page type decides which layout renders on the site. You can fully edit every field
        after choosing.
      </p>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {pageTypes.map((p) => (
          <div
            key={p.type}
            className="border border-gray-200 bg-gray-50 rounded-lg p-4 cursor-pointer hover:shadow-lg transition-shadow duration-200 flex flex-col"
            onClick={() => handleSelect(p.type)}
          >
            <h2 className="text-xl font-semibold mb-2">{p.title}</h2>
            <p className="text-gray-600 mb-4 text-sm flex-grow">{p.description}</p>
            <div className="h-40 w-full mb-4">{p.skeleton}</div>
            <button className="bg-red-600 text-white w-full py-2 rounded font-semibold hover:bg-red-700">
              Use {p.title}
            </button>
          </div>
        ))}
      </div>
    </div>
  );
}
